export default __webpack_public_path__ + "static/media/greenscreen2.5a505325.jpg";